var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
/**
 * Use this to incorporate CSS variable overrides into a component's styles.
 */
export function useBaseStyle(hawkinsCssVariables, userCssVariables, userStyle) {
    return React.useMemo(function () {
        if ((!userCssVariables || !Object.keys(userCssVariables).length) &&
            (!userStyle || !Object.keys(userStyle).length)) {
            return undefined;
        }
        return __assign(__assign({}, Object.entries(userCssVariables || {}).reduce(function (result, _a) {
            var _b = __read(_a, 2), key = _b[0], val = _b[1];
            result[hawkinsCssVariables[key]] = val;
            return result;
        }, {})), userStyle);
    }, [hawkinsCssVariables, userCssVariables, userStyle]);
}
//# sourceMappingURL=useBaseStyle.js.map